module.exports = __webpack_public_path__ + "static/media/navbar_logo.d872d716.png";